import script from "./goRinSyo0083.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0083.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0083.vue?vue&type=style&index=0&id=d2a00cbe&lang=scss"

const __exports__ = script;

export default __exports__